import Table from "../components/Table";
import Sidebar from "../../../components/partials/Sidebar";
import Header from "../../../components/partials/Header";
import Breadcrumb from "../../../components/Breadcrumb";
import { useEffect, useRef, useState } from "react";
import $ from "jquery";
import config from "../../../config";
import Pagination from "../../../components/Pagination";
import "../style.css";
import Swal from "sweetalert2";
import Tippy from "@tippyjs/react";
import filterIcon from "../../../images/icons/filter.png";
import Filter from "../components/Filter";
import moment from "moment";
import ExcelDownload from "../components/ExcelDownload";
import { millionComma } from "../../../utils";

const PaymentSummary = (props) => {
  const [user, setUser] = useState({});
  const [is_cashier, setIs_cashier] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
      setIs_cashier(
        JSON.parse(localStorage.getItem("inventory")).userData?.comp_data[0]
          ?.is_cashier_report
      );
    }
  }, []);

  const getBranchList = async (inputValue, callback) => {
    let branches = props.branchList.filter((b) =>
      b.label
        .toString()
        .toLowerCase()
        .includes(inputValue.toString().toLowerCase())
    );
    callback(branches);
  };

  const getUserList = async (inputValue, callback) => {
    if (inputValue.toString().length > 2) {
      await $.post(
        `${config.apiUrl}/user/searchUser`,
        JSON.stringify({
          is_active: 1,
          paginate: 0,
          role_id: [4, 7],
          user_name: inputValue.toString(),
          branch_id:
            filter.branch_id ||
            JSON.parse(localStorage.getItem("inventory"))?.userData
              ?.branch_data?.[0]?.branch_id,
        }),
        function (res) {
          callback(
            res.data.list.map((v) => {
              return {
                value: v.user_id,
                label: v.user_name,
              };
            })
          );
        }
      );
    } else {
      callback([]);
    }
  };

  const isMounted = useRef(false);

  const filterList = [
    { name: "from_date", label: "From Date", type: "date", required: "true" },
    { name: "to_date", label: "To Date", type: "date", required: "true" },
    {
      name: "branch_id",
      label: "Branch Name",
      type: "async_select",
      required: false,
      visible: [1, 2].includes(user.role_id),
      values: getBranchList,
    },
    {
      name: "created_by",
      label: "Cashier Name",
      type: "async_select",
      //   required: true,
      values: getUserList,
      visible: [1].includes(is_cashier) && user?.role_id != 7,
    },
  ];

  const columnList = [
    {
      label: "Branch",
      value: "branch_name",
      visible: [1, 2].includes(user.role_id),
    },
    {
      label: "Cashier Name",
      value: "user_name",
      visible: [1].includes(is_cashier),
    },
    { label: "Payment Mode", value: "payment_mode_id", visible: true },
    { label: "Op. Bal", value: "op_st", visible: true },
    { label: "", value: "op_st_modal", visible: false },

    { label: "Purchase", value: "pur_amt", visible: true },
    { label: "", value: "pur_amt_modal", visible: false },
    { label: "Purchase Rtn", value: "pur_rtn_amt", visible: true },
    { label: "", value: "pur_rtn_amt_modal", visible: false },

    { label: "Challan", value: "chal_amt", visible: true },
    { label: "", value: "chal_amt_modal", visible: false },
    { label: "Challan Rtn", value: "chal_rtn_amt", visible: true },
    { label: "", value: "chal_rtn_amt_modal", visible: false },
    { label: "Expense", value: "exp_amt", visible: true },
    { label: "", value: "exp_amt_modal", visible: false },
    { label: "Income", value: "inc_amt", visible: true },
    { label: "", value: "inc_amt_modal", visible: false },
    { label: "Withdrawal Amount", value: "wd_amt", visible: true },
    { label: "", value: "wd_amt_modal", visible: false },
    { label: "Cl. Bal", value: "cl_st", visible: true },
    { label: "", value: "cl_st_modal", visible: false },
  ];

  const [filter, setFilter] = useState(() => {
    let filters = {};
    filterList.forEach((list) => {
      if (list.name === "from_date" || list.name === "to_date") {
        filters[list.name] = moment().format("YYYY-MM-DD");
      } else {
        filters[list.name] = "";
      }
    });
    return filters;
  });
  const [column, setColumn] = useState(() => columnList);
  useEffect(() => {
    setColumn(() => columnList);
  }, [user]);
  const [row, setRow] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [showFilter, setShowFilter] = useState(true);
  const [showLoading, setShowLoading] = useState(false);

  const getList = async () => {
    if (!filter?.from_date || !filter?.to_date) {
      Swal.fire("Error", "Date is Required");
      return;
    }

    if (user?.role_id === 3 || user?.role_id === 4) {
      filter.branch_id = JSON.parse(
        localStorage.getItem("inventory")
      )?.userData?.branch_data?.[0]?.branch_id;
    }

    setShowLoading(true);
    await $.post(
      `${config.apiUrl}/report/listPaymentSummary`,
      JSON.stringify({
        ...filter,
        paginate: 1,
        is_active: 1,
        page_no: currentPage - 1,
        page_size: pageSize,
      })
    )
      .done((res) => {
        if (res?.data?.list?.length > 0) {
          let cols = columnList.map((col) => col.value);
          let paymentModes = [
            "Opening",
            "Cash",
            "Credit",
            "Stanbic Bank",
            "Centenary Bank",
            "DFCU Bank",
            "Closing",
          ];
          const payDtl = JSON.stringify([
            { mode: "Cash UGX", conv: 1, conv_amt: 0, amt: 0 },
            { mode: "USD", conv: 1, conv_amt: 0, amt: 0 },
            { mode: "Momo Pay", conv: 1, conv_amt: 0, amt: 0 },
            { mode: "Airtel Money", conv: 1, conv_amt: 0, amt: 0 },
          ]);
          setRow(() => {
            let resArr = res?.data?.list || [];
            return resArr.map((r) => ({
              branch_name: r?.branch_name || "",
              user_name: r?.user_name || "",
              payment_mode_id: paymentModes?.[r?.payment_mode_id] || "",
              op_st: r?.payment_mode_id > 2 ? "-" : millionComma(r?.op_st || 0),
              op_st_modal:
                r?.payment_mode_id > 2 ? payDtl : r?.op_st_modal || payDtl,

              pur_amt: millionComma(r?.pur_amt || 0),
              pur_amt_modal: r?.pur_amt_modal || payDtl,
              pur_rtn_amt: millionComma(r?.pur_rtn_amt || 0),
              pur_rtn_amt_modal: r?.pur_rtn_amt_modal || payDtl,

              chal_amt: millionComma(r?.chal_amt || 0),
              chal_amt_modal: r?.chal_amt_modal || payDtl,
              chal_rtn_amt: millionComma(r?.chal_rtn_amt || 0),
              chal_rtn_amt_modal: r?.chal_rtn_amt_modal || payDtl,

              exp_amt: millionComma(r?.exp_amt || 0),
              exp_amt_modal: r?.exp_amt_modal || payDtl,
              inc_amt: millionComma(r?.inc_amt || 0),
              inc_amt_modal: r?.inc_amt_modal || payDtl,

              wd_amt: millionComma(r?.wd_amt || 0),
              wd_amt_modal: r?.wd_amt_modal || payDtl,

              cl_st: r?.payment_mode_id > 2 ? "-" : millionComma(r?.cl_st || 0),
              cl_st_modal:
                r?.payment_mode_id > 2 ? payDtl : r?.cl_st_modal || payDtl,
            }));
          });
          setTotalPage(() => res?.data?.count || 0);
          setCurrentPage(() => currentPage);
        } else {
          setTotalPage(() => 0);
          setCurrentPage(() => 1);
          setRow(() => []);
        }
        setShowLoading(false);
      })
      .fail((err) => {
        Swal.fire(
          "",
          err?.responseJSON?.data?.message || err?.responseJSON?.message
        );
        setShowLoading(false);
      });
  };

  const clearList = () => {
    setFilter(() => {
      let filters = {};
      filterList.forEach((list) => {
        filters[list.name] = "";
      });
      return filters;
    });
    setTotalPage(() => 0);
    setCurrentPage(() => 1);
    setRow(() => []);
  };

  useEffect(() => {
    if (isMounted.current) getList();
    isMounted.current = true;
  }, [currentPage]);
  const validateDownload = (filter) => {
    if (!filter?.from_date || !filter?.to_date) {
      Swal.fire("Error", "Date is Required");
      return false;
    }

    return true;
  };

  const changePageSize = (e) => {
    const newSize = e.target.value;
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (row.length > 0) {
      getList();
    }
  }, [pageSize]);
  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2">
          <Header />
          <main className="bg-white rounded-4" id="ledger">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col-md">
                  <Breadcrumb path={["Cash Summary"]} />
                </div>

                <div className="col-md text-end">
                  <select value={pageSize} onChange={(e) => changePageSize(e)}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <Tippy content="Filter" trigger="mouseenter">
                    <img
                      src={filterIcon}
                      className="img-fluid mx-2 icon"
                      width="35px"
                      height="35px"
                      alt=""
                      role="button"
                      onClick={(e) => setShowFilter(!showFilter)}
                    />
                  </Tippy>

                  <ExcelDownload
                    validate={validateDownload}
                    filter={filter}
                    filename="CashSummary"
                    url={`${config.apiUrl}/report/listPaymentSummary`}
                  />
                </div>
              </div>

              <Filter
                show={showFilter}
                filterList={filterList}
                showLoading={showLoading}
                handler={{ getList, clearList, state: { filter, setFilter } }}
              />

              <Table tableData={{ column, row }} handler={{ getList }} />

              <div className="row  mt-4">
                <div className="col">
                  <Pagination
                    nPages={Math.ceil(totalPage / Number(pageSize))}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default PaymentSummary;
